/* ==========================================================================
   BD Collection — filter drawer + auto-submit filters/sort
   File: assets/bd-collection.js
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('bd-filter-form');
  var sortSelect = document.getElementById('bd-sort-select');
  var filterToggle = document.getElementById('bd-filter-toggle');
  var filterClose = document.getElementById('bd-filter-close');
  var sidebar = document.getElementById('bd-filter-sidebar');
  var overlay = document.getElementById('bd-filter-overlay');

  // Sort dropdown auto-submits the filter form (linked via form="bd-filter-form")
  if (sortSelect && form) {
    sortSelect.addEventListener('change', function () {
      form.submit();
    });
  }

  if (form) {
    // Checkboxes auto-submit immediately
    var checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(function (input) {
      input.addEventListener('change', function () {
        form.submit();
      });
    });

    // Price inputs submit on blur/enter (change event), not on every keystroke
    var priceInputs = form.querySelectorAll('input[type="number"]');
    priceInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        form.submit();
      });
    });
  }

  // Mobile filter drawer
  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (filterToggle) filterToggle.addEventListener('click', openSidebar);
  if (filterClose) filterClose.addEventListener('click', closeSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);
});